import { Block } from 'factories/block';
import getStore from 'services/getStore';

export function getAllAssessmentQuestions() {
  const state = getStore().getState();

  const allAssessmentQuestions = (Object.values(
    state.blocks
  ) as Block[]).reduce((acc, curr) => {
    return curr.type.toLowerCase() === 'assessmentquestion'
      ? [...acc, curr]
      : acc;
  }, [] as Block[]);

  return allAssessmentQuestions;
}
